import { Button, Stack } from '@chakra-ui/react';
import { useMemo } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { PATHS } from 'router/routes';
import KnowledgeBase from './KnowledgeBase';
import AgentGreeting from './AgentGreeting';
import ChatSimulation from './ChatSimulation';
import CallTransfers from './CallTransfers';
import MoreSettings from './MoreSettings';
import TrainingGuide from './TrainingGuide';
import FullAgentConfiguration from './FullAgentConfiguration';
import { X } from 'lucide-react';

const AgentConfiguration = () => {
    const route = useNavigate();
    const location = useLocation();

    const ROUTES = [
        {
            value: 'training',
            label: 'Agent Configuration',
            path: PATHS.AGENT_CONFIGURATION_TRAINING,
            element: <FullAgentConfiguration />,
        },
        { value: 'chat', label: 'Chat Simulation', path: PATHS.AGENT_CONFIGURATION_CHAT, element: <ChatSimulation /> },
        {
            value: 'transfers',
            label: 'Call Transfers',
            path: PATHS.AGENT_CONFIGURATION_TRANSFERS,
            element: <CallTransfers />,
        },
        {
            value: 'more-settings',
            label: 'More Settings',
            path: PATHS.AGENT_CONFIGURATION_MORE_SETTINGS,
            element: <MoreSettings />,
        },
    ];

    const onBack = () => {
        route(PATHS.MY_AGENT);
    };

    const activeTab = useMemo(() => {
        const splitLink = location.pathname.split('/');

        return splitLink[splitLink.length - 1];
    }, [location]);

    return (
        <div className='min-h-screen bg-white'>
            <header className='bg-white border-b p-4 sticky top-0 z-50 flex justify-between items-center'>
                <h1 className='text-2xl font-bold text-[#000000]'>Agent Configuration</h1>
                <Button onClick={onBack} variant='ghost' size='icon' aria-label='Close configuration panel'>
                    <X className='h-6 w-6' />
                </Button>
            </header>{' '}
            <main className='container mx-auto p-4'>
                <Stack spacing='10'>
                    <Stack direction='row' flexWrap='wrap'>
                        {ROUTES.map((tab) => (
                            <Button
                                key={tab.value}
                                size='sm'
                                variant='ghost'
                                {...(activeTab === tab.path && { backgroundColor: '#5612f8', color: 'white' })}
                                onClick={() => route(tab.path)}
                                borderRadius='sm'
                                _active={{ backgroundColor: 'none' }}
                                _hover={{ backgroundColor: 'none' }}
                            >
                                {tab.label}
                            </Button>
                        ))}
                    </Stack>{' '}
                    <Outlet />
                </Stack>
            </main>
        </div>
    );
};

export default AgentConfiguration;
